var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-12"},[_c('data-cards'),_c('div',{staticClass:"ghost-vertical-separator"}),_c('room-charts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }